var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class StreamedPackages {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get packageShelf() {
        return this.parent;
    }
    get Edit() {
        const Edit = this.packageShelf.Edit.streamedPackage; // stream in parallel
        if (!this.Defer)
            return undefined;
        return Edit;
    }
    get EditLazy() {
        const EditLazy = this.packageShelf.EditLazy.streamedPackage; // stream in parallel
        if (!this.Edit)
            return undefined;
        return EditLazy;
    }
    get Abfrager() {
        return this.packageShelf.Abfrager.streamedPackage;
    }
    get Draft() {
        return this.packageShelf.Draft.streamedPackage;
    }
    get Defer() {
        return this.packageShelf.Defer.streamedPackage;
    }
    get Lazy() {
        return this.packageShelf.Lazy.streamedPackage;
    }
    get Rare() {
        return this.packageShelf.Rare.streamedPackage;
    }
    get Grundschule() {
        return this.packageShelf.Grundschule.streamedPackage;
    }
    get Plugin() {
        return this.packageShelf.Plugin.streamedPackage;
    }
    get Exotic() {
        return this.packageShelf.Exotic.streamedPackage;
    }
    get Layout() {
        return this.packageShelf.Layout.streamedPackage;
    }
    get Mobile() {
        return this.packageShelf.Mobile.streamedPackage;
    }
    get MobileLazy() {
        return this.packageShelf.MobileLazy.streamedPackage;
    }
    get Large() {
        return this.packageShelf.Large.streamedPackage;
    }
    get Multi() {
        return this.packageShelf.Multi.streamedPackage;
    }
}
__decorate([
    computed
], StreamedPackages.prototype, "Edit", null);
__decorate([
    computed
], StreamedPackages.prototype, "EditLazy", null);
